<template>
  <div>
    <el-row>
      <el-col>
        <p>供应商：{{ supplierName }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-card :body-style="{ padding: '0px' }">
          <img :src="imgFile" class="image" style="width: 100%">
          <div style="padding: 10px;">
            <p>上传日期：{{ timeCurr }}</p>
            <el-button size="medium" type="text" class="button" @click="openImg">查看大图</el-button>
            <el-button size="medium" type="text" class="button" @click="downloadImg">下载文件</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col>
        <el-dialog title="农残检测报告" center :visible.sync="imgFormVisible" width="500px" :close-on-click-modal="false">
          <img :src="imgFile" class="image" style="width: 100%">
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tmpImg: require('@/assets/images/tmp.jpg'),
      imgFormVisible: false,
      supplierName: sessionStorage.getItem('supplier_T'),
      imgFile: '',
      timeCurr: '',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 7,
        QUALIFY_ID: this.$route.params.id,
      };
      http.post(params).then((result) => {
        this.imgFile = result[0].FILE_URL;
        this.timeCurr = result[0].CREATE_TIME;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openImg() {
      this.imgFormVisible = true;
    },
    downloadIamge(imgsrc, name) { // 下载图片地址和图片名
      const image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
        const a = document.createElement('a'); // 生成一个a元素
        const event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name || 'photo'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downloadImg() {
      this.downloadIamge(this.imgFile, 'pic');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tracing/supplierImg.vue